import { observer } from 'mobx-react-lite'
import { type BookkeepingManagerViewModel } from '@/features/admin/bookkeeping/BookkeepingManagerViewModel'
import { BookkeepingManager } from '@/features/admin/bookkeeping/BookkeepingManager'
import { BookkeepingManagerActionFilterContainer } from '@/features/admin/bookkeeping/components/BookkeepingManagerActionFilter/BookkeepingManagerActionFilterContainer'
import { BookkeepingManagerTableContainer } from '@/features/admin/bookkeeping/components/BookkeepingManagerTable/BookkeepingManagerTableContainer'
import { BookkeepingManagerDetailsContainer } from '@/features/admin/bookkeeping/components/BookkeepingManagerDetails/BookkeepingManagerDetailsContainer'
import { WorkspaceFilterViewHeadingContainer } from '@/components/WorkspaceFilterViewHeadingContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'

export interface BookkeepingManagerContainerProps {
  vm: BookkeepingManagerViewModel
}

export const BookkeepingManagerContainer = observer(
  function BookkeepingManagerContainer({
    vm,
  }: BookkeepingManagerContainerProps) {
    useDocumentTitle('Bookkeeping Manager')
    useActivation(vm)

    return vm.fetch.match({
      pending: () => <ContentLoading />,
      rejected: (err) => <ContentError error={err} />,
      resolved: () => (
        <BookkeepingManager
          heading={
            <WorkspaceFilterViewHeadingContainer
              allOptionText="All workspaces"
              primaryText="Bookkeeping manager"
              filter={vm.searcher.workspaceFilter}
              testId="workspace-filter-view-heading-dropdown"
            />
          }
          isSideSheetVisible={vm.detailsVm.modal.showing}
          actionFilter={
            <BookkeepingManagerActionFilterContainer
              filter={vm.searcher.actionFilter}
            />
          }
          total={vm.items.length}
          searchText={vm.searcher.searchText.value}
          onSearchTextChange={vm.searcher.searchText.change}
          table={<BookkeepingManagerTableContainer vm={vm} />}
          details={<BookkeepingManagerDetailsContainer vm={vm.detailsVm} />}
        />
      ),
    })
  },
)
